/**
 * The organization this browser last started a sign-in for or entered the app
 * in (OPSSTD-9930), so the next sign-in goes straight to that organization's
 * page instead of asking for the name again.
 *
 * Written from both sides, which is why it sits above both route groups:
 * `/o/$slug/login` when a sign-in starts, and the `(private)` session gate on
 * every way in, because an invitation signs the person in without passing
 * through `/o/$slug/login` at all.
 *
 * It survives sign-out on purpose: the person who signs out is, almost
 * always, the person who signs back in, and making them retype the name is
 * the step this exists to remove. The name is one they typed themselves, so
 * remembering it reveals nothing the anti-enumeration answer protects.
 *
 * Every call is wrapped because a private window or blocked site data makes
 * storage throw, and losing the shortcut is the right answer there — the
 * page that asks for the name still works.
 */
const STORAGE_KEY = 'instance.last-organization'

export function readLastOrganization() {
	try {
		return localStorage.getItem(STORAGE_KEY)
	} catch {
		return null
	}
}

export function rememberOrganization(slug: string) {
	try {
		localStorage.setItem(STORAGE_KEY, slug)
	} catch {
		// Storage is unavailable: the next sign-in asks for the name again.
	}
}

/**
 * Only when the refused name is the remembered one. A typo in the field
 * must not erase an organization that still works.
 */
export function forgetOrganization(slug: string) {
	try {
		if (localStorage.getItem(STORAGE_KEY) === slug) {
			localStorage.removeItem(STORAGE_KEY)
		}
	} catch {
		// Storage is unavailable, so there is nothing remembered to forget.
	}
}
